import {
  Checkbox,
  FormControlLabel,
  FormLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useMarketplaceStore } from "../../../store/useMarketplaceStore";
import { useTranslation } from "../../../hooks/useTranslation";
import { AddFormValues } from "./AddRestrictionDialog";

export const CountryList = () => {
  const { translate } = useTranslation("common.components.countryList");
  const {
    control,
    watch,
    formState: { errors },
    getValues,
    register,
  } = useFormContext<AddFormValues>();

  const allSelected = watch("applyToAllMarketplaces");

  const getSelectedItems = (selected: number, currentValues: number[]) => {
    const currentIndex = currentValues.indexOf(selected);
    const newSelectedCountries = [...currentValues];

    if (currentIndex === -1) {
      newSelectedCountries.push(selected);
    } else {
      newSelectedCountries.splice(currentIndex, 1);
    }

    return newSelectedCountries;
  };

  const countries = useMarketplaceStore((state) => state.countries);

  return (
    <>
      <Typography variant="body1" fontWeight="bold">
        {translate("choose")}
      </Typography>
      <FormControlLabel
        control={<Checkbox checked={getValues("applyToAllMarketplaces")} />}
        label={translate("all")}
        {...register("applyToAllMarketplaces", {
          validate: (value, formValue) =>
            value || formValue.marketplaceIds.length > 0,
        })}
      />
      <Controller
        name="marketplaceIds"
        control={control}
        rules={{
          validate: (value, formValue) =>
            formValue.applyToAllMarketplaces || value.length > 0,
        }}
        render={({ field }) => (
          <List
            dense
            sx={{
              border:
                !!errors.applyToAllMarketplaces && !!errors.marketplaceIds
                  ? "1px solid #d32f2f"
                  : "1px solid #ccc",
              borderRadius: "4px",
              maxHeight: "250px",
              overflow: "auto",
            }}
          >
            {countries.map((marketplace) => (
              <ListItemButton
                key={marketplace.id}
                disabled={allSelected}
                onClick={() =>
                  field.onChange(getSelectedItems(marketplace.id, field.value))
                }
              >
                <ListItem
                  secondaryAction={
                    <Checkbox
                      edge="end"
                      checked={
                        allSelected || field.value.includes(marketplace.id)
                      }
                    />
                  }
                >
                  <img
                    src={marketplace.flagUrl + "?width=40"}
                    alt={marketplace.countryName}
                  />
                  <ListItemText
                    primary={marketplace.countryName}
                    sx={{ marginLeft: "16px" }}
                  />
                </ListItem>
              </ListItemButton>
            ))}
          </List>
        )}
      />
      <FormLabel
        error={!!errors.applyToAllMarketplaces && !!errors.marketplaceIds}
      >
        <Typography variant="caption" marginLeft="16px">
          {!!errors.applyToAllMarketplaces && !!errors.marketplaceIds
            ? translate("countriesError")
            : ""}
        </Typography>
      </FormLabel>
    </>
  );
};
